import { FunctionComponent, ReactNode } from "react"
import { Outlet } from "react-router-dom"
import { GET_USERS } from "../../../graphql/queries/users"
import { useQuery } from "@apollo/client"
import styles from "./user.module.scss"
import {
    ErrorMessage,
    SyncLoaderComponent,
    EmptyState,
} from "../../../components/shared/graphQlResponse"
import { formatAdminUsersTableData } from "../../../components/usersAdminTable/tableUtils"
import UsersAdminTable from "../../../components/usersAdminTable/table"
import { useViewerContext } from "../../../context/ViewerContext"
import Policy_OrganizationMembership from "../../../rolePolicy/organizationMembership"

const UsersTable: FunctionComponent = () => {
    const { role } = useViewerContext().getViewer()

    // if role is org admin or org member, we want to fetch only active users
    // if role is ppo admin, we want to fetch all users
    const activeOnly =
        Policy_OrganizationMembership.canOnlyFetchActiveUsers(role)

    const { error, data, loading } = useQuery(GET_USERS, {
        variables: {
            first: 5000,
            SubjectFilter: {
                activeOnly: activeOnly,
            },
        },
        fetchPolicy: "network-only",
    })

    let body: ReactNode
    if (error) {
        body = (
            <ErrorMessage
                outSideDivStyle={styles.error}
                message="There was a problem fetching users."
            />
        )
    } else if (loading) {
        body = <SyncLoaderComponent outSideDivStyle={styles.loader} />
    } else if (data) {
        const formattedData = formatAdminUsersTableData(data)
        if (formattedData.length === 0) {
            body = <UsersEmptyState />
        } else {
            body = <UsersAdminTable data={formattedData} />
        }
    }

    return (
        <>
            <Outlet />
            <div className={styles.container}>{body}</div>
        </>
    )
}

const UsersEmptyState: FunctionComponent = () => {
    return (
        <EmptyState outSideDivStyle={styles.emptyStateContainer}>
            <div className={styles.emptyTitle}> No users found.</div>
            <div className={styles.emptySubtitle}>
                Please reach out to{" "}
                <a href="mailto:support@petropower.com">
                    support@petropower.com
                </a>
            </div>
        </EmptyState>
    )
}

export default UsersTable
